import { render, staticRenderFns } from "./skeleton-circle.vue?vue&type=template&id=fe5d3524&"
import script from "./skeleton-circle.vue?vue&type=script&lang=js&"
export * from "./skeleton-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports